import type { LotteryPurchasesConfig } from '../../lotteryPurchases.types.ts';
import { ROUTES } from './routes/routes.ts';

const LOTTERY_PURCHASES: LotteryPurchasesConfig = {
  showsTicketStateSwitcher: false,
  showsLegacySiteNotification: false,
  emptyStateCtaHref: ROUTES.HOME,
  jackpotWinThreshold: 99_999_900,
};

export { LOTTERY_PURCHASES };
